import React, {Component} from "react";
import Packages from './components/Packages';
import FilterGroup from './components/FilterGroup';
import './App.css';
import axios from "axios";
import { createBrowserHistory } from 'history';

let apiString = '/wp-json/wordpressmega/v2/packages'

if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
    apiString = 'http://soundfangled.local/wp-json/wordpressmega/v2/packages'
}

const history = createBrowserHistory();

function HasPackages(props) {
    if (props.packages  && props.packages.length) {
        return <Packages packages={props.packages} location_id={props.location_id}/>;
    }
    return <h4>No Results</h4>;
}


class App extends Component {

    constructor(props) {
        super(props);
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        this.state = {
            loading: false,
            packages :[],
            order : 'asc',
            minBudget: urlParams.get('min-budget') ? urlParams.get('min-budget') : "",
            maxBudget: urlParams.get('max-budget') ? urlParams.get('max-budget') : "",
            capacity: urlParams.get('capacity') ? urlParams.get('capacity') : 50,
            outside_compatible: urlParams.get('outside_compatible') ? urlParams.get('outside_compatible') : false,
            // need to set location ID
            location_id: urlParams.get('location_id') ? urlParams.get('location_id') : "489",
            filterGroups : [],
            packageFilterProperties: [
                {
                    name: 'Features',
                    taxonomy: 'package_features',
                    slug: 'features',
                    filters: urlParams.get('features') ?  urlParams.get('features').split(',') : [],
                },
                {
                    name: 'Event Type',
                    taxonomy: 'package_event_types',
                    slug: 'event-types',
                    filters: urlParams.get('event-types') ?  urlParams.get('event-types').split(',') : [],
                },
                {
                    name: 'Hire Type',
                    taxonomy: 'package_hire_types',
                    slug: 'hire-types',
                    filters: urlParams.get('hire-types') ?  urlParams.get('hire-types').split(',') : [],
                },
                {
                    name: 'Activities',
                    taxonomy: 'package_activities',
                    slug: 'activities',
                    filters: urlParams.get('activities') ?  urlParams.get('activities').split(',') : [],
                }
            ],

            timer: null

        }
      }

    filterPackages = (value, packageFilterTaxonomy) => {
         for (let i=0; i < this.state.packageFilterProperties.length; i++) {
           
            if (this.state.packageFilterProperties[i].taxonomy === packageFilterTaxonomy) {
                // console.log('hello', this.state.packageFilterProperties[i].taxonomy, packageFilterTaxonomy);
                let filters = this.state.packageFilterProperties[i].filters;
                const index = filters.indexOf(value);
                    
                if (index > -1) {
                    filters.splice(index, 1);
                } else {
                    filters.push(value);
                }
                
                this.setState({
                    packageFilterProperties: [
                        ...this.state.packageFilterProperties.slice(0,i),
                       Object.assign({}, this.state.packageFilterProperties[i], filters),
                       ...this.state.packageFilterProperties.slice(i+1)
                    ]
                  });
            }
        }
        this.getPackages();
    }

    orderPackages = (event) => {
        
        let packs = this.state.packages;
        this.setState({ order:  event.target.value });
        if(event.target.value === 'asc') {
            packs.sort((a, b) => a.price - b.price);
        } else {
            packs.sort((a, b) => b.price - a.price);
        }
        this.setState({ packages: packs });
    }


    getQueryParamsString = () => {
        let x = {
            "min-budget": this.state.minBudget,
            "max-budget": this.state.maxBudget,
            capacity: this.state.capacity,
            outside_compatible: this.state.outside_compatible,
            location_id: this.state.location_id,
            // need to unhardcode this and loop through packageFilterProperties
            features: this.state.packageFilterProperties[0].filters,
            "event-types": this.state.packageFilterProperties[1].filters,
            "hire-types": this.state.packageFilterProperties[2].filters,
            activities: this.state.packageFilterProperties[3].filters,
        };

        let params = new URLSearchParams(x);
        let keysForDel = [];
        params.forEach((value, key) => {
          if (value === '') {
            keysForDel.push(key);
          }
        });
        
        keysForDel.forEach(key => {
          params.delete(key);
        });

        return params.toString();
    }

    getParamsApiString = () => {
        let queryParams = this.getQueryParamsString();
        
        return apiString + '?' + queryParams;
    }

    getPackages = () => {
        let self = this;
        this.setState({loading: true});

        axios.get(this.getParamsApiString())
        .then( (res) => {
            console.log('packages', res.data.packages);
            let packs = res.data.packages;
            if(this.state.order === 'asc') {
                packs.sort((a, b) => a.price - b.price);
            } else {
                packs.sort((a, b) => b.price - a.price);
            }
            
            this.setState({
                packages: packs,
                filterGroups: res.data.filterGroups
            })            
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
        .then(function () {
            // always executed
            self.setState({loading: false});
        });

        history.push({
            pathname: '',
            search: '?' + this.getQueryParamsString()
        })

        //  console.log('packages', this.state.packages)
        //  console.log('filterGroups', this.state.filterGroups)
    }

    componentDidMount(){
        this.getPackages();
    }

    isCapacity  = (value) => {
        // capacity from db is a string so using ==
        return this.state.capacity == value;
    }

    hasFilters = () => {
        return this.state.capacity 
            || this.state.maxBudget 
            || this.state.minBudget 
            || this.state.outside_compatible
            || this.hasPackageFilters();
    }

    hasPackageFilters = () => {
        for (let i = 0; i < this.state.packageFilterProperties.length; i++) {
            if (this.state.packageFilterProperties[i].filters.length) {
                return true;
            }
        }
        return false;
    }

    updateLocation = (event) => {
       
        console.log('update Location', event, event.target.value)

        clearTimeout(this.timer);
        this.setState({location_id: event.target.value});

        this.state.timer = setTimeout(() => {
            this.getPackages();
        }, 1000);
    }

    updateMinBudget = (event) => {
       
        console.log('update MinBudget', event, event.target.value);

        clearTimeout(this.timer);
        this.setState({minBudget: event.target.value});

        this.state.timer = setTimeout(() => {
            this.getPackages();
        }, 1000);
    }

    updateMaxBudget = (event) => {
       
        console.log('update MaxBudget', event, event.target.value)

        clearTimeout(this.timer);
        this.setState({maxBudget: event.target.value});

        this.state.timer = setTimeout(() => {
            this.getPackages();
        }, 1000);
    }

    updateCapacity = (event) => {
       
        console.log('update Capacity', event, event.target.value)
        
        this.setState({capacity: event.target.value}, () =>  this.getPackages() );
        // this.getPackages();
    }

    updateOutsideCompatible = (event) => {
        this.setState({outside_compatible: ! this.state.outside_compatible}, () =>  this.getPackages() );
        // this.getPackages();
    }

    clearFilters = () => {
        const filters = this.state.packageFilterProperties;
        for (let i = 0; i < filters.length; i++) {
            filters[i].filters = [];
        }

        this.setState({
            capacity: 50,
            outside_compatible: false,
            maxBudget: '',
            minBudget: '',
            packageFilterProperties: filters
        }, () => {
            this.getPackages();
        });
    }

    handleClearFilters = (e) => {
        e.preventDefault();
        this.clearFilters();
    }

    findPackageFilter = (taxonomyName) => {
        for (let i=0; i < this.state.packageFilterProperties.length; i++) {
            if (this.state.packageFilterProperties[i].taxonomy === taxonomyName) {
                return this.state.packageFilterProperties[i];
            }
        }
        return null;
    }

    getFilterCount = (taxonomyName) => {
        const packageFilter = this.findPackageFilter(taxonomyName);
        return packageFilter?.filters.length || 0;
    }

    // setCapacityChecked = (value) => {
    //     console.log('set capacity', value, this.state.capacity)
    //     return value === this.state.capacity ? true : false;
    // }

    render() {

        return (
            <div className="App">
                <div className="container-xxl">
                    <div className="row">
                        <div className="col col-lg-4 col-xl-3  packages-sidebar position-relative">
                            <div>
                                <h3 className="h4 mb-2">Filter your results</h3>
                                <p className="mb-5">
                                    {/* Showing 12 of 48 results */}
                                    </p>

                                <button className="btn btn-outline-primary w-100 d-lg-none" type="button" data-bs-toggle="collapse" data-bs-target="#mobileFilters"
                                aria-expanded="false" aria-controls="mobileFilters">View Filters</button>
                                <div className="collapse d-lg-block" id="mobileFilters">

                                    <form>

                                        <div className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" name="outside_compatible" onChange={this.updateOutsideCompatible} checked={this.state.outside_compatible}/>
                                            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Outside event?</label>
                                        </div>


                                        <button className="btn btn-sidebar collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#eventCapacity" aria-expanded="false" aria-controls="eventCapacity">
                                           Capacity
                                        </button>
                                        <div className="collapse" id="eventCapacity">
                                            <div className="btn-group mb-5 capacity-buttons" role="group" aria-label="Capacity toggle button group" id="capacity">
                                                <input type="radio" className="btn-check" name="capacity" id="capacity50" value="50" onChange={this.updateCapacity} checked={this.isCapacity(50)}/>
                                                <label className="btn  btn-sm btn-outline-primary" htmlFor="capacity50">50</label>
                                                
                                                <input type="radio" className="btn-check" name="capacity" id="capacity100" value="100" onChange={this.updateCapacity} checked={this.isCapacity(100)}/>
                                                <label className="btn  btn-sm btn-outline-primary" htmlFor="capacity100">100 </label>

                                                <input type="radio" className="btn-check" name="capacity" id="capacity150" value="150" onChange={this.updateCapacity} checked={this.isCapacity(150)}/>
                                                <label className="btn  btn-sm btn-outline-primary" htmlFor="capacity150">150</label>
                                                
                                                <input type="radio" className="btn-check" name="capacity" id="capacity250" value="250" onChange={this.updateCapacity} checked={this.isCapacity(250)}/>
                                                <label className="btn  btn-sm btn-outline-primary" htmlFor="capacity250">250</label>
                                                
                                                <input type="radio" className="btn-check" name="capacity" id="capacity500" value="500" onChange={this.updateCapacity} checked={this.isCapacity(500)}/>
                                                <label className="btn  btn-sm btn-outline-primary" htmlFor="capacity500">500</label>
                                                
                                                <input type="radio" className="btn-check" name="capacity" id="capacity750" value="750" onChange={this.updateCapacity} checked={this.isCapacity(750)}/>
                                                <label className="btn  btn-sm btn-outline-primary" htmlFor="capacity750">750</label>
                                                
                                                <input type="radio" className="btn-check" name="capacity" id="capacity1000" value="1000" onChange={this.updateCapacity} checked={this.isCapacity(1000)}/>
                                                <label className="btn  btn-sm btn-outline-primary" htmlFor="capacity1000">1000+</label>
                                            </div>
                                        </div>

                                        <button className="btn btn-sidebar collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#eventLocation" aria-expanded="false" aria-controls="eventLocation">
                                           Location
                                        </button>
                                        <div class="collapse" id="eventLocation">
                                            <div class="d-flex btn-group-vertical mb-4 flex-column flex-buttons flex-wrap flex-lg-nowrap"  role="group" aria-label="Location select">
                                                <button type="button" class={this.state.location_id === "490" ? "btn btn-outline-primary text-white active" : "btn btn-outline text-dark"} value="490" onClick={this.updateLocation}>London</button>
                                                <button type="button" class={this.state.location_id === "489" ? "btn btn-outline-primary text-white active" : "btn btn-outline text-dark"} value="489" onClick={this.updateLocation}>Brighton</button>
                                                <button type="button" class={this.state.location_id === "493" ? "btn btn-outline-primary text-white active" : "btn btn-outline text-dark"} value="493" onClick={this.updateLocation}>Manchester</button>
                                                <button type="button" class={this.state.location_id === "494" ? "btn btn-outline-primary text-white active" : "btn btn-outline text-dark"} value="494"  onClick={this.updateLocation}>Nationwide</button>
                                            </div>
                                        </div>

                                        {/* <button className="btn btn-sidebar collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#eventBudget" aria-expanded="false" aria-controls="eventBudget">
                                           Budget
                                        </button>
                                        <div className="collapse" id="eventBudget">
                                            <div className="d-flex budget-container mb-5 align-items-center">
                                                <div className="input-group"> 
                                                    <span className="input-group-text">£</span>
                                                    <input name="min-budget" value={this.state.minBudget} onChange={this.updateMinBudget} type="text" className="form-control" aria-label="Dollar amount (with dot and two decimal places)"/>
                                                </div>
                                                <span>to</span>
                                                <div className="input-group">
                                                    <span className="input-group-text">£</span>
                                                    <input name="max-budget" value={this.state.maxBudget} onChange={this.updateMaxBudget} type="text" className="form-control" aria-label="Dollar amount (with dot and two decimal places)"/>
                                                </div>
                                            </div>
                                        </div> */}


                                        {
                                            this.state.filterGroups.map((filterGroup, i) => {
                                            return (
                                                <FilterGroup 
                                                key={filterGroup.taxonomy} 
                                                filterPackages={this.filterPackages}
                                                numberChecked={this.getFilterCount(filterGroup.taxonomy)}
                                                filterGroup={filterGroup} 
                                                />
                                            )})
                                        }   
                                        
                                        {this.hasFilters() &&
                                        <button type="button" className="btn btn-primary w-100 mt-4" onClick={this.handleClearFilters}>Clear All</button>
                                        }
                                    </form>
                                </div>
                            </div>
                        </div> 
                        <div className="col-lg-8 col-xl-9 packages-results">
                            {/* <h2>Packages</h2> */}

                            <div class="filter-results-tags row mb-5 d-flex justify-content-end flex-row">
                                <div class="col-8 col-xs-5 col-sm-5 col-md-4 col-lg-5  col-xl-4 d-flex sort-by align-items-center">
                                    <label for="tags">Sort by:</label>
                                    <select class="form-select" aria-label="Order by price" onChange={this.orderPackages}>
                                        <option value='asc' selected={this.state.order === 'asc'}>Price (Low to High)</option>
                                        <option value='desc' selected={this.state.order === 'desc'}>Price (High to Low)</option>
                                    </select>
                                </div>
                            </div>
                            {!this.state.loading &&
                            <HasPackages packages={this.state.packages} location_id={this.state.location_id}/>
                            }
                            <img width={100} height={100} className={"packages-results__loader img-fluid" + (this.state.loading ? ' packages-results__loader--show' : '')} src='/wp-content/themes/wordpressmega/dist/assets/images/ajax-loader.gif' alt='Loading' />
                        </div>
                    </div>
                </div>            
            </div>
        );
    }
}

export default App;